import React from "react";
import { LegalLayout, H2, P, UL } from "@/components/LegalLayout";
import { COMPANY } from "@/data/site";

export default function Terms() {
  return (
    <LegalLayout title="Website Terms & Conditions" updated="June 2026">
      <P>
        These terms and conditions govern your use of the {COMPANY.name} website. By using this website you accept
        these terms in full. If you disagree with any part of them, please do not use our website.
      </P>

      <H2>1. Use of the website</H2>
      <UL
        items={[
          "This website is provided for general information about our services. You may use it for lawful purposes only.",
          "You must not use the website in any way that causes, or may cause, damage to the website or impairment of its availability.",
          "You must not use the website to copy, store, distribute or transmit any malicious code or material.",
        ]}
      />

      <H2>2. Intellectual property</H2>
      <P>
        Unless otherwise stated, we or our licensors own the intellectual property rights in the website and its
        content, including text, layout, graphics and branding. You may view and print pages for your own personal use,
        but you must not reproduce or exploit content without our written permission.
      </P>

      <H2>3. Accuracy and disclaimers</H2>
      <P>
        We take care to ensure the information on this website is accurate, but it is provided for general information
        only and without warranties of any kind. Descriptions of services and projects are indicative and do not form
        a contract or quotation.
      </P>

      <H2>4. Limitation of liability</H2>
      <P>
        To the fullest extent permitted by law, we exclude liability for any loss or damage arising from your use of,
        or inability to use, this website. Nothing in these terms limits or excludes liability for death or personal
        injury caused by negligence, or for fraud, or any other liability that cannot lawfully be excluded.
      </P>

      <H2>5. Links to other websites</H2>
      <P>
        Where our website contains links to third-party websites, these are provided for convenience only. We have no
        control over the content of those sites and accept no responsibility for them.
      </P>

      <H2>6. Governing law and jurisdiction</H2>
      <P>
        These terms are governed by and construed in accordance with the laws of England and Wales, and any disputes
        will be subject to the exclusive jurisdiction of the courts of England and Wales.
      </P>

      <H2>7. Contact</H2>
      <P>
        Questions about these terms can be sent to{" "}
        <a className="underline" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>. Registered address:{" "}
        {COMPANY.registeredAddress}.
      </P>
    </LegalLayout>
  );
}
